/* This file is autogenerated, see readme.md for instructions */
import PlusCircleFillSvgIcon from '@bloomreach/banana-theme/icons/plus-circle-fill.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const PlusCircleFillIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <PlusCircleFillSvgIcon />
    </Icon>
  );
});

PlusCircleFillIcon.displayName = 'PlusCircleFillIcon';

export default PlusCircleFillIcon;
